import { Component, Input, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { FraccionamientoCatalogo } from '../../model/catalogo.model';
import { CaInputDirective } from '@global-front-components/ui/input';
import { Recibo } from '../../model/poliza.model';

@Component({
	selector: 'app-datos-economicos',
	standalone: true,
	imports: [
		CommonModule,
		CaInputDirective,
		CaFormFieldComponent,
		TranslateModule,
		CaLabel
	],
	templateUrl: './datos-economicos.component.html',
	styleUrls: ['./datos-economicos.component.scss']
})
export class DatosEconomicosComponent {
	@Input() recibo: Recibo;
	@Input() fraccionamiento: FraccionamientoCatalogo;

}
